import { c as _c } from "react/compiler-runtime";
import { DangerButton, PrimaryButton } from '@systemeio/ui';
import { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import { ItemIntegrationParams, ItemIntegrationParamsProps } from './item-integration-params';
type CommonProps = {
  removeIntegration: () => Promise<void>;
  reconnectIntegration?: () => Promise<void>;
  showReconnectButton?: boolean;
  onLoading?: (loading: boolean) => void;
};
type Props = ({
  email?: never;
  createdAt?: never;
  status?: never;
  customParams: ItemIntegrationParamsProps['params'];
} & CommonProps) | ({
  email: string;
  createdAt: string;
  status: string;
  customParams?: never;
} & CommonProps);
export const ItemIntegration = t0 => {
  const $ = _c(39);
  const {
    email,
    status,
    createdAt,
    customParams,
    showReconnectButton,
    removeIntegration,
    reconnectIntegration,
    onLoading
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingRemoval, setIsLoadingRemoval] = useState(false);
  let t1;
  if ($[0] !== onLoading || $[1] !== reconnectIntegration || $[2] !== showReconnectButton) {
    t1 = async () => {
      if (reconnectIntegration && showReconnectButton) {
        setIsLoading(true);
        onLoading?.(true);
        await reconnectIntegration();
        setIsLoading(false);
        onLoading?.(false);
      }
    };
    $[0] = onLoading;
    $[1] = reconnectIntegration;
    $[2] = showReconnectButton;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onReconnectIntegration = t1;
  let t2;
  if ($[4] !== onLoading || $[5] !== removeIntegration) {
    t2 = async () => {
      setIsLoadingRemoval(true);
      onLoading?.(true);
      await removeIntegration();
      setIsLoadingRemoval(false);
      onLoading?.(false);
    };
    $[4] = onLoading;
    $[5] = removeIntegration;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onRemoveIntegration = t2;
  let t3;
  if ($[7] !== createdAt || $[8] !== customParams || $[9] !== email || $[10] !== status || $[11] !== t) {
    t3 = customParams ?? [{
      title: t("global.email_address"),
      value: email
    }, {
      title: t("global.created_on"),
      value: createdAt
    }, {
      title: t("global.status"),
      value: status
    }];
    $[7] = createdAt;
    $[8] = customParams;
    $[9] = email;
    $[10] = status;
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3) {
    t4 = <div className="mb-5 flex gap-2.5 lg:mb-7 lg:gap-4"><ItemIntegrationParams params={t3} /></div>;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = reconnectIntegration && "justify-evenly gap-2";
  let t6;
  if ($[15] !== t5) {
    t6 = twMerge("flex justify-center", t5);
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== isLoading || $[18] !== onReconnectIntegration || $[19] !== reconnectIntegration || $[20] !== showReconnectButton || $[21] !== t) {
    t7 = reconnectIntegration && showReconnectButton && <PrimaryButton onClick={() => onReconnectIntegration()} isFetching={isLoading}>{t("dashboard.user_settings.integrations_page.reconnect")}</PrimaryButton>;
    $[17] = isLoading;
    $[18] = onReconnectIntegration;
    $[19] = reconnectIntegration;
    $[20] = showReconnectButton;
    $[21] = t;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== onRemoveIntegration) {
    t8 = () => onRemoveIntegration();
    $[23] = onRemoveIntegration;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t) {
    t9 = t("dashboard.user_settings.integrations_page.disconnect");
    $[25] = t;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== isLoading || $[28] !== isLoadingRemoval || $[29] !== t8 || $[30] !== t9) {
    t10 = <DangerButton disabled={isLoading} isFetching={isLoadingRemoval} onClick={t8}>{t9}</DangerButton>;
    $[27] = isLoading;
    $[28] = isLoadingRemoval;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t6 || $[34] !== t7) {
    t11 = <div className={t6}>{t7}{t10}</div>;
    $[32] = t10;
    $[33] = t6;
    $[34] = t7;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== t11 || $[37] !== t4) {
    t12 = <div className="mb-4 lg:mb-6">{t4}{t11}</div>;
    $[36] = t11;
    $[37] = t4;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  return t12;
};